import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fcom-selectable-card-footer',
  template: '<ng-content></ng-content>',
  styleUrls: ['./selectable-card-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectableCardFooterComponent {}
